<template></template>

<script>
import { SET_AUTH } from "@/store/mutations";
import store from "@/store/index.js";
import FollowersAPI from "@/api/followers.js";

var Twitch = window.Twitch.ext;

export default {
  name: "TwitchExt",
  data() {
    return {
      twitch: Twitch,
    };
  },
  created() {
    this.twitch.onAuthorized(async (auth) => {
      const parts = auth.token.split(".");
      const { channelId, token, userId } = auth;

      store.commit(SET_AUTH, {
        channelId,
        token,
        userId,
      });
    });

    if (!this.twitch.viewer.id) {
      ga("set", "userId", this.twitch.viewer.opaqueId);
    } else {
      ga("set", "userId", this.twitch.viewer.id);
    }

    // Prevent duplicate listeners due to HMR
    this.twitch.unlisten("broadcast", this.listenCb);
    this.twitch.listen("broadcast", this.listenCb);

    this.twitch.unlisten("global", this.listenCb);
    this.twitch.listen("global", this.listenCb);

    this.twitch.actions.onFollow(this.userFollowed);

    this.twitch.bits.onTransactionCancelled(this.bitsTxCancelled);
    this.twitch.bits.onTransactionComplete(this.bitsTxCompleted);
  },
  methods: {
    bitsTxCancelled() {
      ga("send", {
        hitType: "event",
        eventCategory: "bits",
        eventAction: "processed",
        eventLabel: "bits-tx-cancelled",
      });
    },
    userFollowed(followed, channelName) {
      if (followed) {
        FollowersAPI.userFollowed(channelName);
        this.eventBus.$emit("user-followed", channelName);
        ga("send", {
          hitType: "event",
          eventCategory: "followers",
          eventAction: "processed",
          eventLabel: "user-follow-complete",
        });
        return;
      }
      ga("send", {
        hitType: "event",
        eventCategory: "followers",
        eventAction: "processed",
        eventLabel: "user-follow-cancelled",
      });
    },
    bitsTxCompleted(txObj) {
      this.eventBus.$emit("bits-tx-completed", txObj);
    },
    listenCb(target, contentType, message) {
      const { type, data } = JSON.parse(message);

      switch (type) {
        case "newFollower":
          var follower = JSON.parse(data);
          this.eventBus.$emit("new-follower", follower.username);
          break;
        case "followersUpdate":
          var update = JSON.parse(data);
          this.eventBus.$emit("followers-update", update.followers);
          break;
        case "newDonatorMsg":
          var tx = JSON.parse(data);
          this.eventBus.$emit("new-donator-msg", tx);
          break;
        case "messagesUpdate":
          var tx = JSON.parse(data);
          this.eventBus.$emit("messages-update", tx);
          break;
        case "customNotification":
          var notification = JSON.parse(data);
          this.eventBus.$emit("custom-notification", notification);
          break;
        case "streamChange":
          var streamChange = JSON.parse(data);
          this.eventBus.$emit("stream-change", streamChange);
          break;
        case "userGrantedAuth":
          this.eventBus.$emit("user-granted-auth");
          break;
        case "userGrantedStreamlabsAuth":
          this.eventBus.$emit("user-granted-streamlabs-auth");
          break;
        case "subscribersUpdate":
          var subscribers = JSON.parse(data);
          this.eventBus.$emit("subscribers-update", subscribers);
          break;
        case "newSubscriber":
          var subscriber = JSON.parse(data);
          this.eventBus.$emit("new-subscriber", subscriber);
          break;
        case "subscriberBoast":
          var subscriber = JSON.parse(data);
          this.eventBus.$emit("subscriber-boast", subscriber);
          break;
        case "hypetrainUpdate":
          var hypeTrainUpdateEvent = JSON.parse(data);
          this.eventBus.$emit("hypetrain-update", hypeTrainUpdateEvent);
          break;
        case "hypetrainEvent":
          var hypeTrainEvent = JSON.parse(data);
          this.eventBus.$emit("hypetrain-update", hypeTrainEvent);
          break;
        case "goalsProgressUpdate":
          var goalProgress = JSON.parse(data);
          this.eventBus.$emit("goals-progress-update", goalProgress);
          break;
        case "channelPointsRewardRedemptionAdd":
          var channelpointsRewardRedemptionAdd = JSON.parse(data);
          this.eventBus.$emit(
            "channel-points-reward-redemption-add",
            channelpointsRewardRedemptionAdd
          );
        default:
          return;
      }

      ga("send", {
        hitType: "event",
        eventCategory: "pubsub-event",
        eventAction: "processed",
        eventLabel: type,
      });
    },
  },
};
</script>
